export const MEMBERSHIP_PRICE_MNT = 9900;

export type FeedbackCategory = 'bug' | 'payment' | 'account' | 'suggestion' | 'other';
export type FeedbackStatus = 'open' | 'resolved' | 'dismissed';

export interface FeedbackDiagnosticContext {
  roomId?: string;
  gameType?: string;
  phase?: string;
  connectionStatus?: string;
  latencyMs?: number;
  lastError?: string;
  userAgent?: string;
  url?: string;
  screenSize?: string;
}

export interface FeedbackRecord {
  id: string;
  user_id: string | null;
  display_name: string;
  contact?: string | null;
  category: FeedbackCategory;
  message: string;
  status: FeedbackStatus;
  context?: FeedbackDiagnosticContext | null;
  admin_note?: string | null;
  created_at: string;
  updated_at: string;
}

export interface SubmitFeedbackPayload {
  category: FeedbackCategory;
  message: string;
  contact?: string;
  context?: FeedbackDiagnosticContext;
  honeypot?: string;
  dwellMs?: number;
}

export type BillingResource = 'users' | 'payments' | 'subscriptions' | 'coupons' | 'redemptions' | 'audit' | 'feedback';
export interface PaymentRecord {
  id: string;
  user_id: string;
  amount: number;
  currency: 'MNT';
  status: 'creating' | 'pending' | 'paid' | 'review';
  purpose?: 'vip' | 'tsai_50' | 'tsai_150' | 'tsai_400';
  coupon_code?: string | null;
  /** VIP months fixed when the order is created; null for Tsai packs or legacy orders. */
  vip_months?: number | null;
  invoice_id: string | null;
  provider_payment_id: string | null;
  created_at: string;
  paid_at: string | null;
  qr_text: string | null;
  qr_image?: string | null;
  urls: { name: string; link: string; logo?: string }[];
}
export interface CouponRecord {
  code: string;
  active: boolean;
  starts_at: string;
  expires_at: string;
  max_uses: number;
  per_user_limit: number;
  usage_count: number;
  months: number;
  /** Optional total QPay price for this coupon's VIP months, in whole MNT. Omit for a free coupon. */
  price_mnt?: number | null;
  /** Whole-percent reduction from 9,900 MNT per VIP month. Exclusive with other price modes. */
  discount_percent?: number | null;
  /** Whole-MNT reduction from 9,900 MNT per VIP month. Exclusive with other price modes. */
  discount_mnt?: number | null;
}
export interface BillingPage {
  resource: BillingResource;
  page: number;
  hasMore: boolean;
  rows: Record<string, unknown>[];
}
export interface CouponQuote {
  code: string;
  kind: 'free' | 'paid';
  amount: number;
  months: number;
}
export type AdminMutation =
  | { kind: 'tokens'; userId: string; amount: number; reason: string; requestId: string }
  | { kind: 'subscription'; userId: string; months: number; reason: string; requestId: string }
  | { kind: 'revoke'; userId: string; reason: string; requestId: string }
  | { kind: 'admin'; userId: string; isAdmin: boolean; reason: string; requestId: string }
  | { kind: 'coupon'; coupon: Omit<CouponRecord, 'usage_count'>; reason: string; requestId: string }
  | { kind: 'feedback'; feedbackId: string; status: FeedbackStatus; adminNote?: string; reason: string; requestId: string };
